var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSliderNextArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 34,
    width: 34,
    height: 34,
    rx: 17,
    transform: "rotate(-180 34 34)",
    fill: "#FF8C42",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7072 16.2929C20.8947 16.4804 21 16.7347 21 16.9999C21 17.2651 20.8947 17.5194 20.7072 17.7069L15.0502 23.3639C14.958 23.4594 14.8476 23.5356 14.7256 23.588C14.6036 23.6404 14.4724 23.668 14.3396 23.6692C14.2068 23.6703 14.0752 23.645 13.9523 23.5947C13.8294 23.5444 13.7177 23.4702 13.6238 23.3763C13.5299 23.2824 13.4557 23.1708 13.4054 23.0479C13.3551 22.925 13.3298 22.7933 13.331 22.6605C13.3321 22.5277 13.3597 22.3965 13.4121 22.2745C13.4645 22.1525 13.5407 22.0421 13.6362 21.9499L18.5862 16.9999L13.6362 12.0499C13.4541 11.8613 13.3533 11.6087 13.3555 11.3465C13.3578 11.0843 13.463 10.8335 13.6484 10.6481C13.8338 10.4627 14.0846 10.3575 14.3468 10.3552C14.609 10.3529 14.8616 10.4537 15.0502 10.6359L20.7072 16.2929Z",
    fill: "#FF8C42"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderNextArrow);
export default __webpack_public_path__ + "static/media/slider-next-arrow.a08a15c97f39dd161014af2121869705.svg";
export { ForwardRef as ReactComponent };